import { AxiosResponse } from 'axios';
import type { IGetCasinoGamesResponse } from 'interfaces/new-casino';

export const checkBackendAnomaly = (
  data: AxiosResponse<IGetCasinoGamesResponse>
) => {
  return data.data.status === -1;
};
